/*************************************************************************
 * 
 * KLEAREXPRESS CONFIDENTIAL
 * __________________
 * 
 *  Copyright (c) 2018 - 2018 KlearExpress Corporation.
 *  All Rights Reserved.
 * 
 * NOTICE:  All information contained herein is, and remains
 * the property of KlearExpress Corporation and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to KlearExpress Corporation
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from KlearExpress Corporation.
 */


import React, { Component } from 'react';
import './styles/css/account-info-3.css';
import { Button, Segment, Form, Input, Header, Radio, Checkbox, Grid, Progress } from 'semantic-ui-react';
import { Link, Redirect} from 'react-router-dom';
import API from "../utility/API";
import ProgressBar from "../components/progress-bar";

class AccountInfo3 extends Component {
  constructor() {
    super();
    this.state = {
      toNextPage: false,
      bondNumber: '',
      bondAmount: '',
      bond: '',
      bondType: '',
    }
  }
  handleChange = (e, { name, value }) => this.setState({ [name]: value })

  getCookieValue = (name) => {
    var b = document.cookie.match('(^|;)\\s*' + name + '\\s*=\\s*([^;]+)');
    return b ? b.pop() : '';
  }

  handleSubmit = () => {
    const { bondNumber, bondAmount, bond, bondType } = this.state
    this.setState({ bondNumber, bondAmount, bond, bondType })

    API.bondInfo(
      this.getCookieValue('kxCustomerToken'),
      this.state.bondNumber,
      this.state.bondAmount,
      this.state.bond,
      this.state.bondType
    ).then(response => {
      return response.json()
    }).then(responseData => {
      console.log(responseData);
    }).then(
      this.setState({ toNextPage: true })
    ).catch(err => console.log('ERROR:', err))

    // this.props.storeProgressData("ai3", "item progress-green")
  }

  handleSkip = () => {
    this.props.storeProgressData("ai3", "piece progress-gray")
  }

  render() {

    const { bondNumber, bondAmount } = this.state

    if (this.state.toNextPage === true) {
      this.props.storeProgressData("ai3", "piece progress-green")
			return <Redirect to='/accountInfo4' />
    }

    return (
      <div>
        <ProgressBar progressData={this.props.progressData}/>
        <h2 className="ai2h2">Account Information</h2>
        <Segment padded='very' className="account-ino-3-form">
          <Form>
            <Header as='h1'>Bond Information</Header>
            <Form.Group widths="equal">
                    <Form.Radio
                      name="bond"
                      label='My Own'
                      value='my own'
                      checked={this.state.bond === 'my own'}
                      onChange={this.handleChange.bind(this)}
                    />

                    <Form.Radio
                      name="bond"
                      label='KlearExpress'
                      value='klearexpress'
                      checked={this.state.bond === 'klearexpress'}
                      onChange={this.handleChange.bind(this)}
                    />

                    <Form.Radio
                      name="bond"
                      label='Broker'
                      value='broker'
                      checked={this.state.bond === 'broker'}
                      onChange={this.handleChange.bind(this)}
                    />
            </Form.Group>

            <Form.Field>
              <label className="account-info-3-label">BOND NUMBER</label>
              <Input className="account-info-3-input"
                placeholder='Enter Number Here...'
                name="bondNumber"
                value={bondNumber}
                onChange={this.handleChange.bind(this)}
              />
              <br />
              <br />
              <Input className="account-info-3-input"
                placeholder='Enter Amount Here...'
                name='bondAmount'
                value={bondAmount}
                onChange={this.handleChange.bind(this)}
              />
              <br />
              <br />
            </Form.Field>

            <Form.Group>

              <Form.Radio
                name="bondType"
                label='Single'
                value='SINGLE_TRANSACTION'
                checked={this.state.bondType === 'SINGLE_TRANSACTION'}
                onChange={this.handleChange.bind(this)}
                width={6}
              />


              <Form.Radio
                name="bondType"
                label='Continuous'
                value='CONTINUOUS'
                checked={this.state.bondType === 'CONTINUOUS'}
                onChange={this.handleChange.bind(this)}
                width={6}
              />

            </Form.Group>

            <br />
            <br />
          </Form>
          <div className="ai3-buttonRow">

          <Link to='/accountInfo2'>
                <Button type='submit' className="account-info-3-cancel">CANCEL</Button>
              </Link>
              <Link to='/accountInfo4'>
                <Button type='submit' className="account-info-3-skip" onClick={this.handleSkip}>SKIP THIS</Button>
              </Link>
              {/* <Link to='/accountInfo4'> */}
                <Button type='submit' className="account-info-3-save" onClick={this.handleSubmit} color="twitter">SAVE & NEXT</Button>
              {/* </Link> */}
            </div>
        </Segment>
      </div>
      // </div>
    );
  }
}

export default AccountInfo3;
